import React from "react";
import styled from "styled-components";
import AboutMe from "./AboutMe";
import MyInfo from "./MyInfo";
import StackProgress from "./Skills/Skills";
import Portfolio from "./Portfolio";
import { ThemeSwitcher } from "../ThemeSwitcher";
import Footer from "./Footer";

function Home() {
  const themesColor = React.useContext(ThemeSwitcher);

  return (
    <Container>
      <Wrap id="home">
        <MyInfo />
      </Wrap>

      <OtherWrapper id="about me">
        <AboutMe />
      </OtherWrapper>

      <OtherWrapper id="skills">
        <StackProgress />
      </OtherWrapper>

      {/* <OtherWrapper id="portfolio">
        <Portfolio />
      </OtherWrapper> */}
      <Footer />
    </Container>
  );
}

export default Home;


const Container = styled.div`
  min-height: calc(100vh - 70px);
  padding: 0 calc(3.5vw + 5px);
  padding-top: 100px;
  transform: translateX(0);
  position: relative;
  overflow: hidden;
  background: ${(themesColor) => themesColor.theme.back};
`;

const Wrap = styled.div`
  color: ${(themesColor) => themesColor.theme.title};
  margin: 60px auto;
  max-width: 1200px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 768px) {
    margin: 0 auto;
    padding-top: 90px;
    display: flex;
    justify-content: center;
    flex-direction: column-reverse;
    &:first-child {
      padding-top: 0;
    }
  }
  a {
    color: ${(themesColor) => themesColor.theme.title};
  }
`;

const OtherWrapper = styled(Wrap)``;
